module.exports = __webpack_public_path__ + "img/goal-six-br.bd6b707b.png";